import { THEME } from "@/3514/theme"
import { buildCssClassName, getLinkDecorationTwClasses } from "@/3514/utils"

export default {
    container: (): string => "flex flex-col",
    wrapper: (): string => "flex flex-col",
    modules: {
        emptyMessages: (): string => "rounded-[5px] px-[15px] py-[10px] bg-gray-500",
        container: (): string => "flex flex-col gap-y-[30px]",
        wrapper: (): string => "flex flex-col gap-y-[30px]",
        item: (): string => "px-[5px] md:px-[20px] flex flex-col gap-y-[15px]",
        title: (): string =>
            buildCssClassName("border-b-[1px] pb-[5px]", {
                "border-blue-500": import.meta.env.PROD,
                "border-blue-300": import.meta.env.DEV
            }),
        list: (): string => "flex flex-col gap-y-[15px]",
        listItem: (): string => "flex flex-col gap-y-[5px]",
        listItemFeature: (): string => "flex items-center gap-x-[10px]",
        getEditorInsertableClasses(identifier: string): string {
            return `
                .${identifier} * { 
                  color: ${THEME.COLORS.gray[200]};
                  font-weight: ${THEME.FONT_WEIGHTS[300]};
                  line-height: ${THEME.LINE_HEIGHTS[21]}px;
                  font-size: ${THEME.FONT_SIZES[14]}px;
                  text-wrap: pretty;
                  hyphens: auto;
                  @media screen and (min-width: ${THEME.BREAKPOINTS.lg}) { 
                    font-size: ${THEME.FONT_SIZES[16]}px;
                    line-height: ${THEME.LINE_HEIGHTS[24]}px;
                  }
                }
                .${identifier} strong { font-weight: ${THEME.FONT_WEIGHTS[800]}; }
                .${identifier} ul { line-height: ${THEME.LINE_HEIGHTS[24]}px; list-style-position: inside; list-style-type: disc; }
                .${identifier} a { color: ${THEME.COLORS.accent}; }
                .${identifier} a:hover, .${identifier} a:focus { text-underline-offset: 5px; outline: none; }
            `
        }
    },
    modal: {
        opener: (): string =>
            buildCssClassName(
                "mx-[5px]",
                "md:mx-[15px]",
                "group",
                "w-min",
                "relative",
                "after:cursor-pointer",
                "after:absolute",
                "after:inset-[-10px]",
                "after:content-['']"
            ),
        openerText: (): string =>
            buildCssClassName("w-max", getLinkDecorationTwClasses({ color: "blue", offset: 3, isGroup: true })),
        header: (): string => "pb-[8px]",
        body: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "max-w-[95%]",
                "md:max-w-[620px]",
                "w-full",
                "max-h-fit",
                "md:max-h-[685px]",
                "py-[35px]",
                "px-[30px]",
                "bg-white",
                "rounded-[10px]",
                "relative",
                "h-screen",
                "md:h-fit"
            ),
        bodyHolder: (): string => "flex flex-col gap-y-[40px]",
        bodyLikertWrapper: (): string =>
            buildCssClassName(
                "relative",
                "max-h-[470px]",
                "md:max-h-[490px]",
                "no-scrollbar",
                "overflow-y-auto",
                "overscroll-contain",
                "touch-auto",
                "pt-[8px]",
                "md:pt-[0px]"
            )
    }
} as const
